import { render } from "./SideNavItem.vue?vue&type=template&id=cc1637cc"
import script from "./SideNavItem.vue?vue&type=script&lang=js"
export * from "./SideNavItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__